import {combineReducers} from "redux";
import {routerReducer} from "react-router-redux";
import Settings from "./Settings";
import Auth from "./Auth";
import AuthSurvey from "./AuthSurvey";
import Common from "./Common";

/**
 * Projects
 */
 import Projects from "./Projects"

/**
 * Dashboard
 */
import Dashboard from "./Dashboard";
import Bannerblocks from "./Dashboard/Bannerblocks";

/**
 * System
 */
import Sync from "./System/Sync";
import Organisations from "./System/Organisations";
import Roles from "./System/Roles";
import Users from "./System/Users";
import Textblocks from "./System/Textblocks";
import Deploy from "./System/Deploy";
/**
 * Assessments Page
 */
import Assessments from "./Assessments"
import Explainers from "./Assessments/Explainers";

/**
 * Clients
 */
import Clients from "./Clients";
import ClientTabNotes from "./Clients/Tabs/Notes";
import ClientTabAssessment from "./Clients/Tabs/Assessments";
import ClientTabAssessmentReport from "./Clients/Tabs/Assessments/Report";
import ClientTabAssessmentResponse from "./Clients/Tabs/Assessments/Response";

import ClientTabCorrespondence from "./Clients/Tabs/Correspondence";
import ClientTabDetail from "./Clients/Tabs/Detail";
import TrialUser from "./System/TrialUser";

const ClientTabAssessmentReducers = combineReducers({
  assessments_ui: ClientTabAssessment,
  report: ClientTabAssessmentReport,
  response: ClientTabAssessmentResponse,
})

const clientTabs = combineReducers({
  notes_tab: ClientTabNotes,
  assessments_tab: ClientTabAssessmentReducers,
  correspondence_tab: ClientTabCorrespondence,
  detail_tab: ClientTabDetail
});

const clients = combineReducers({
  client_ui: Clients,
  client_tabs: clientTabs
});

/**
 * Assessments page
 */
const assessments = combineReducers({
  assessments_ui: Assessments,
  explainers: Explainers,
});

/**
 * Dashboard page
 */
const dashboard = combineReducers({
  dashboard_ui: Dashboard,
  bannerblocks: Bannerblocks,
})

/**
 * System
 */
const system = combineReducers({
  /**
   * Projects
   */
  projects: Projects,
  organisations: Organisations,
  textblocks: Textblocks,
  
  /**
   * System
   */
  sync: Sync,
  roles: Roles,
  users: Users,
  deploy: Deploy,
  trial_users: TrialUser,
})

// Summarize - ready to use
const reducers = combineReducers({
  routing: routerReducer,
  settings: Settings,
  auth: Auth,
  authSurvey: AuthSurvey,
  commonData: Common,
  dashboard,
  clients,
  assessments,
  system,
});

export default reducers;
